<template>
  <div>
    <!-- 修改用户备注弹出框  -->
    <el-dialog
      :title="platFormTitle"
      :visible.sync="dialogFormVisible"
      width="50%"
      class="dialog"
      center
    >
      <div class="contents1">
        <el-form
          :model="platForm"
          :rules="rules"
          ref="platForm"
          label-width="auto"
        >
          <div class="d-flex a-center mb-15">
            <div class="mr-15">客户姓名：{{ platForm.member_name }}</div>
            <div>客户电话：{{ platForm.member_mobile }}</div>
          </div>
          <el-form-item label="客户备注" prop="remark">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              v-model="platForm.remark"
              maxlength="20"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFrom" :loading="submitLoading"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { BASE } from "@/api";
import { postTakeOrderPlacenoRemarkSave } from "@/api/customPit.js";

export default {
  props: ["id"],
  name: "uploadFile",
  data() {
    return {
      BASE,
      role: sessionStorage.getItem("manageIsdentity"),
      token: sessionStorage.getItem("token"),
      submitLoading: false,
      dialogFormVisible: false, //编辑弹窗
      platFormTitle: "", //弹框title
      platForm: {
        remark: "",
        member_id: "",
        member_name: "",
        member_mobile: "",
      },
      rules: {
        // remark: [{ required: true, message: "请填写备注", trigger: "change" }],
      },
    };
  },
  created() {},
  methods: {
    /**
     *导入
     */
    addData(e) {
      this.platFormTitle = "客户备注";
      this.platForm.remark = e.remark;
      this.platForm.member_id = e.member_id;
      this.platForm.member_name = e.member_name;
      this.platForm.member_mobile = e.member_mobile;
      this.submitLoading = false;
      this.dialogFormVisible = true;
    },
    /**
     * 提交表单
     */
    submitFrom: debounce(function () {
      this.changeRemark();
    }, 300),
    /**
     * 修改用户姓名备注
     */
    async changeRemark() {
      // if (!this.platForm.remark) {
      //   this.$message.error("请填写备注");
      //   return;
      // }
      try {
        const res = await postTakeOrderPlacenoRemarkSave({
          remark: this.platForm.remark,
          member_id: this.platForm.member_id,
        });
        this.$message.success("修改备注成功");
        this.dialogFormVisible = false;
        this.$emit("dialogVisibleChange");
      } catch (error) {
        console.log(error, "postTakeOrderPlacenoRemarkSave");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.contents1 {
  box-sizing: border-box;
  padding: 10px 26px 40px;

  .hide {
    /deep/ .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
